import React from "react";
import AproveIcon from './assets/aprove-icon.svg';
import './Card.css'


export default function Card({ props })
{
    let order
    props.title === 'Безлимитный интернет' ? order = {order: -1} : order = {order: 1} ;
    console.log(props.title)
    let imgClass = props.title === 'Безлимитный интернет' ? 'internet-image' : props.title === "<span class='phone-card-title'>Безлимит</span><br> на все городские номера" ? 'phone-image' : '';

    return (
        <div className="card">
            <img className={`card-image ${imgClass}`} src={ props.img } alt="card"></img>
            <div className="card-description">
                <div className="white-circle">
                    <p className="title-tarif">{ props.tarif }</p>
                    <p style={ order } className="measuring">{ props.measuring }</p>
                </div>
                <div className="card-wrapper">
                    <div className="card-header">
                        <img className="title-icon" src={ props.titleIcon } alt="title-icon"></img>
                        <p className={props.classTitle} dangerouslySetInnerHTML={{__html: props.title}} />
                    </div>
                    <ul className="card-list">
                        {props.benefits.map(benefit => {
                            return <li className="card-item"><img className={`aprove ${benefit == 'Подробная он-лайн детализация звонков' ? 'first-aprove': ''}`} src={ AproveIcon } alt="approve"></img><p className={`benefit-title ${benefit == 'Подробная он-лайн детализация звонков' ? 'phone-benefit': ''}`}>{benefit}</p></li>
                        })}
                    </ul>
                </div>
            </div>
        </div>
    )
}